/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { TypescriptComponent } from 'components/typescriptExample'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import MapSelector from 'components/MapSelector'

import { Mdx, Link } from '@ta-interaktiv/contentbricks'

import { MDXProvider } from '@mdx-js/react'
import styled from 'styled-components'
import DataWrapperChart from 'components/DataWrapperChart'
// TODO Set the correct article ID here
const ARTICLE_ID = '715554641818'

const MapContainer = styled.div`
  margin: auto;
  max-width: 900px;
  @media (max-width: 900px) {
    margin: auto 15px;
  }
`

export function AppComponent() {
  return (
    <MDXProvider
      components={{
        a: props => <Link allowWordWrap {...props} />,
        blockquote: props => <div className='quote-element' {...props} />
      }}
    >
      <div className='index'>
        <Masthead articleId={ARTICLE_ID} />
        <ThemeSwitch />

        <header className='ui vertical  very fitted  segment'>
          <div className='ui container'>
            <div className='ui header'>
              <div className='ta text'>
                <Mdx
                  className='ta text'
                  file={require('text/8UB5B54OLQJC.mdx')}
                />
              </div>
            </div>
          </div>
        </header>

        <div className='ui vertical segment'>
          <div className='ui text container'>
            <div className='ta metainfo'>
              <div className='ta author'>
                Patrick Meier, Andreas Moor, Dominik Balmer
              </div>
            </div>
            <Mdx className='ta text' file={require('text/r-XyK2m695eh.mdx')} />
          </div>
        </div>

        <div className='ui vertical'>
          <div className='ui text container'>
            {/* Die erste Welle */}
            <Mdx className='ta text' file={require('text/AJXiFXk6gOMt.mdx')} />
          </div>
        </div>

        <div className='ui vertical segment'>
          <MapContainer>
            <DataWrapperChart chartId='ESjAe' height={721} autofit />
          </MapContainer>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            {/* Das Tessin in der ersten Welle */}
            <Mdx className='ta text' file={require('text/C2pP2rxqLuuA.mdx')} />
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <DataWrapperChart chartId='mQdoF' height={390} autofit={false} />
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <Mdx className='ta text' file={require('text/fRRxA-O7L2cs.mdx')} />
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            {/* Die zweite Welle */}
            <Mdx className='ta text' file={require('text/RxcqF_TlMAjO.mdx')} />
          </div>
        </div>

        <div className='ui vertical segment'>
          <MapContainer>
            <DataWrapperChart chartId='8DviU' height={721} />
          </MapContainer>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            {/* Freiburg in der zweiten Welle */}
            <Mdx className='ta text' file={require('text/ctkQROEogl-3.mdx')} />
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <DataWrapperChart chartId='7JIaZ' height={400} autofit={false} />
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            {/* Die dritte Welle */}
            <Mdx className='ta text' file={require('text/f15prslWMZR3.mdx')} />
          </div>
        </div>

        <div className='ui vertical segment'>
          <MapContainer>
            <DataWrapperChart chartId='ZhSXT' height={721} />
          </MapContainer>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            {/* Uri */}
            <Mdx className='ta text' file={require('text/RZ42tiT_Mnwj.mdx')} />
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <DataWrapperChart chartId='FSXXI' height={390} autofit={false} />
          </div>
        </div>

        <div className='ui vertical segment'>
          <div className='ta text chart'>
            <MapContainer>
              <MapSelector />
            </MapContainer>
          </div>
        </div>

        <Footer
          articleId={ARTICLE_ID}
          questions={[
            'Wie informativ war der Beitrag?',
            'Wie gefällt Ihnen die Gestaltung?'
          ]}
          credits={[
            [
              'Daten',
              `<p>Das Bundesamt für Gesundheit (BAG) sammelt alle bekannten Covid-19-Fälle basierend auf Meldungen von Spitälern, Laboren oder Ärztinnen und Ärzten. Diese Daten sind personenbezogen und vertraulich. Deshalb gibt das BAG diese Daten nur in aggregierter Form heraus, die keine Rückschlüsse auf einzelne Personen zulasssen. Die hier dargestellten Daten wurden vom BAG mit Hilfe eines Computer-Skripts, welches ursprünglich die NZZ erstellt hat, aufbereitet. Die personenbezogenen Daten werden pro Gemeinde aggregiert, so kann der Datenschutz gewährleistet werden. Die Gruppierung der Daten erfolgt mit einem <a href="https://de.wikipedia.org/wiki/Jenks-Caspall-Algorithmus" target="_blank" rel="nofollow">Jenks natural breaks Algorithmus</a>, der sicherstellt, dass die dargestellten Gruppen gut unterscheidbar sind. Die aggregierten Daten sowie das verwendete Script sind auf 
<a href="https://github.com/tamedia-ddj/2021_04_Covid_Gemeinden" target="_blank" rel="nofollow">Github</a> einsehbar.
Die Daten geben den Wohnort der getesteten Personen an - und nicht den Ort der Ansteckung.</p>`
            ]
          ]}
        />
      </div>
    </MDXProvider>
  )
}
